import { createAsyncThunk } from '@reduxjs/toolkit';
import { EngineRequestDto } from 'shared/api';
import { engineApi } from '../../api/engineApi';

export const getEngines = createAsyncThunk(
  'engines/getEngines',
  async (params: { userId?: number; engineType?: EngineRequestDto.engineType } = {}, { rejectWithValue }) => {
    try {
      const response = await engineApi.getEngines(params.userId, params.engineType);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getEngineById = createAsyncThunk(
  'engines/getEngineById',
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await engineApi.getEngineById(id);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const createEngine = createAsyncThunk(
  'engines/createEngine',
  async (data: EngineRequestDto, { rejectWithValue }) => {
    try {
      const response = await engineApi.createEngine(data);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const updateEngine = createAsyncThunk(
  'engines/updateEngine',
  async ({ id, data }: { id: number; data: EngineRequestDto }, { rejectWithValue }) => {
    try {
      const response = await engineApi.updateEngine(id, data);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const deleteEngine = createAsyncThunk(
  'engines/deleteEngine',
  async (id: number, { rejectWithValue }) => {
    try {
      await engineApi.deleteEngine(id);
      return id;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
